import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from './components/pc-dropdown.vue';
import mobile from './components/mobile-dropdown.vue';
export const info = {
    title: "下拉输入框",
    type: "drop-down-tags",
    icon: "h-icon-all-a-Drop-downsingle-o",
    dataItemType: DataItemType.DropdownMulti,
    formControllerType: FormControlType.DropdownTags,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
